import React, { PureComponent } from "react";
import {
  LineChart,
  Line,
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from "recharts";

export default class OverviewBarChart extends PureComponent {
  render() {
    const { chart, dataKey, data } = this.props;

    const retData = data ? data : [];

    return (
      <ResponsiveContainer width="100%" height="100%">
        <BarChart width={50} height={20} data={retData}>
          <Tooltip position={{ x: 0, y: 60 }} />
          <Bar dataKey={dataKey !== undefined ? dataKey : "Count"} fill="#34D399" />
          <XAxis dataKey={"name"} hide />
        </BarChart>
      </ResponsiveContainer>
    );
  }
}
